import { Avatar, Box, Typography } from '@mui/material';
import { formatDate } from '@qb/frontend/utils/dateFormatter';
type PostAuthorProps = {
  publishDate: string;
  authorName: string;
  authorAvatar: {
    src: string;
    size?: number;
  };
};
export const PostAuthor = ({
  publishDate,
  authorName,
  authorAvatar = {
    src: '',
    size: 46
  }
}: PostAuthorProps) => {
  return <Box sx={{
    display: 'flex',
    gap: 1,
    alignItems: 'center'
  }} data-sentry-element="Box" data-sentry-component="PostAuthor" data-sentry-source-file="PostAuthor.tsx">
      <Avatar src={authorAvatar.src} alt={authorName} sx={{
      width: authorAvatar.size,
      height: authorAvatar.size
    }} data-sentry-element="Avatar" data-sentry-source-file="PostAuthor.tsx" />
      <div>
        <Typography variant="bodySmall" data-sentry-element="Typography" data-sentry-source-file="PostAuthor.tsx">
          by{' '}
          <Typography component="span" variant="bodySmall" sx={{
          color: 'text.primary',
          fontWeight: 'fontWeightBold'
        }} data-sentry-element="Typography" data-sentry-source-file="PostAuthor.tsx">
            {authorName}
          </Typography>
        </Typography>
        <Typography variant="bodySmall" data-sentry-element="Typography" data-sentry-source-file="PostAuthor.tsx">
          {formatDate(new Date(publishDate))}
        </Typography>
      </div>
    </Box>;
};